import React from 'react';

export default function Facing() {
    return (
        <div className="FlatsResultTable-rowFinishing FlatsResultTable-rowFinishingTrue">
            <a href="https://u-city.ru/steps#rec49692114" rel="noopener noreferrer" target="_blank" onClick={e=>e.stopPropagation()}>Предчистовая отделка </a>
        </div>
    )
}